export const environment = {
    production: false,
    creatoradminApi: 'https://dev.creatoradmin.spooorts.de/',
    sporteventApi: 'https://dev.sportevent.spooorts.de/',
    trainingApi: 'https://dev.training.spooorts.de/',
    routeApi: 'https://dev.route.spooorts.de/',
    eventApi: 'https://dev.event.spooorts.de/',
    backofficeApi: 'https://dev.backoffice.spooorts.de/',
    ba2Api: 'https://dev.ba2.spooorts.de/',
    spooortsWebApp: 'https://dev.spooorts.se2.tech/',
    loginApi:"https://dev.login.spooorts.de/login/",
    // spooorts firebase configs 
    // TODO: change for different applications
    firebase: {
        apiKey: "AIzaSyBbkZGm67zcz4QGxAW4_S7q-vZ53T5NlUw",
        authDomain: "",
        projectId:"spooorts-9dcf2",
        storageBucket:"spooorts-9dcf2.firebasestorage.app",
        messagingSenderId:"33955500516",
        appId:"1:33955500516:ios:0143b5d896cb9d617237f1",
        measurementId: "com.spooorts.eventsoriginal"
    }
};